import React, { Fragment } from 'react'

import './styles.scss'

import birdsImg from './img/birds.png'
import lines1Img from './img/lines1.png'
import lines2Img from './img/lines2.png'

import { IntroProps } from '../types'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

const Intro = ({
  coupleData: { coupleSingleName, weddingDate },
  buttonMessage,
  warningMessage,
  locale = 'pt-BR',
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  const date = new Intl.DateTimeFormat(locale)
    .format(new Date(weddingDate.timestamp))
    .replace(/\//g, ' • ')

  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro192">
      <div className="bp1-intro192mobile anima-word-break ">
        <div className="bp1-mainbackground">
          {typeof background !== 'undefined' && background && (
            <img src={background} className="background-image" />
          )}
        </div>
        <div className="bp1-mask"></div>
        <div className="bp1-shape">
          <img alt="Image/" src={lines2Img} className="bp1-lines2" />
          <img alt="Image/" src={lines1Img} className="bp1-lines1" />
        </div>
        <div className="bp1-content-layout-container">
          <div className="bp1-content">
            <div className="bp1-data bp1-intro192-anima-animate-enter">
              <div className="bp1-dayu2022monthu2022year">{date}</div>
            </div>
            <div
              className={`notranslate bp1-names-layout-container ${
                !coupleSingleName.groom && 'singleName'
              }`}
            >
              <div
                className={`bp1-names bp1-intro192-anima-animate-enter4 ${
                  !coupleSingleName.groom && 'singleName'
                }`}
              >
                <div
                  className={`bp1-couplesinglenamegr bp1-intro192-anima-animate-enter1 ${
                    !coupleSingleName.groom && 'singleName'
                  }`}
                >
                  {coupleSingleName.bride}
                </div>
                {!!coupleSingleName.groom && (
                  <Fragment>
                    <div className="bp1-and bp1-intro192-anima-animate-enter2">
                      and
                    </div>
                    <div className="bp1-couplesinglenamebr bp1-intro192-anima-animate-enter3">
                      {coupleSingleName.groom}
                    </div>
                  </Fragment>
                )}
              </div>
            </div>
            <div className="bp1-birds">
              <img
                alt="Image/"
                src={birdsImg}
                className="bp1-birds1 bp1-intro192-anima-animate-enter5"
              />
            </div>
          </div>
        </div>
        <div className="bp1-button-layout-container">
          <div className="bp1-button">
            <div
              className="bp1-sitedecasamentoe"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <div className="bp1-button1" onClick={onSkipIntro}>
              <div className="bp1-button2"></div>
              <div className="bp1-pularintrodu347343o">{buttonMessage}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="bp2-intro192desktop anima-word-break ">
        <div className="bp2-mainbackground">
          {typeof background !== 'undefined' && background && (
            <img src={background} className="background-image" />
          )}
        </div>
        <div className="bp2-mask"></div>

        <div className="bp2-shape">
          <img alt="Image/" src={lines2Img} className="bp2-lines2" />
          <img alt="Image/" src={lines1Img} className="bp2-lines1" />
        </div>

        <div className="bp2-content-layout-container">
          <div className="bp2-content">
            <div className="bp2-data bp2-intro192-anima-animate-enter">
              <div className="bp2-dayu2022monthu2022year">{date}</div>
            </div>
            <div className="bp2-names-layout-container">
              <div
                className={`bp2-names bp2-intro192-anima-animate-enter4 ${
                  !coupleSingleName.groom && 'singleName'
                }`}
              >
                <div
                  className={`bp2-couplesinglenamegr bp2-intro192-anima-animate-enter1 ${
                    !coupleSingleName.groom && 'singleName'
                  }`}
                >
                  {coupleSingleName.bride}
                </div>
                {!!coupleSingleName.groom && (
                  <Fragment>
                    <div className="bp2-and bp2-intro192-anima-animate-enter2">
                      and
                    </div>
                    <div className="bp2-couplesinglenamebr bp2-intro192-anima-animate-enter3">
                      {coupleSingleName.groom}
                    </div>
                  </Fragment>
                )}
              </div>
            </div>
            <div className="bp2-birds">
              <img
                alt="Image/"
                src={birdsImg}
                className="bp2-birds1 bp2-intro192-anima-animate-enter5"
              />
            </div>
          </div>
        </div>
        <div className="bp2-button-layout-container">
          <div className="bp2-button">
            <div
              className="bp2-sitedecasamentoe"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <div className="bp2-button1" onClick={onSkipIntro}>
              <div className="bp2-button2"></div>
              <div className="bp2-pularintrodu347343o">{buttonMessage}</div>
            </div>
          </div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
